/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import MomSysOrderPurchaseDetailButton from "../input/MomSysOrderPurchaseDetailButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import SaveToExcelButton from "../input/SaveToExcelButton";

function EguUglOrderPurchaseDetail(props) {
    const { onSelectMst, onUpdateMaster, onDetailEmpty } = props;

    const id = "EguUglOrderPurchaseDetail";
    const table = "MomSysUglOrderPurchaseDetail";
    const view = "EguVwOrderPurchaseDetail";

    const { t } = useTranslation();

    const [eguUglOrderPurchaseDetailSchema, setEguUglOrderPurchaseDetailSchema] = useState();
    const [eguUglOrderPurchaseDetailGrid, setEguUglOrderPurchaseDetailGrid] = useState();
    const [eguUglOrderPurchaseDetailApi, setEguUglOrderPurchaseDetailApi] = useState();
    const [eguUglOrderPurchaseDetailDataIsEmpty, setEguUglOrderPurchaseDetailDataIsEmpty] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            if (mounted) {
                const schema = await getSchema(table);

                setEguUglOrderPurchaseDetailSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (eguUglOrderPurchaseDetailApi) {
            eguUglOrderPurchaseDetailApi.refresh();
        }
    }, [onSelectMst.orderPurchaseId]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);

        if (eguUglOrderPurchaseDetailApi) {
            eguUglOrderPurchaseDetailApi.refresh();
        }

        if (onUpdateMaster) {
            onUpdateMaster();
        }
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onPartialFailure = (msg) => {
        notifyWarning(msg);

        if (eguUglOrderPurchaseDetailApi) {
            eguUglOrderPurchaseDetailApi.refresh();
        }

        if (onUpdateMaster) {
            onUpdateMaster();
        }
    };

    const onDialogUpdateDetail = () => {
        if (eguUglOrderPurchaseDetailApi) {
            eguUglOrderPurchaseDetailApi.refresh();
        }

        if (onUpdateMaster) {
            onUpdateMaster();
        }
    };

    const doHandleBackendErrorMsg = (reason) => {
        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;
    };

    return (
        <BasicCrudScreenType
            id={id}
            headerTitle={t("term.poDetail")}
            table={table}
            view={view}
            onInitialized={(grid) => {
                setEguUglOrderPurchaseDetailGrid(grid);
            }}
            onApiInitialized={(api) => {
                setEguUglOrderPurchaseDetailApi(api);
            }}
            onLoadData={(data) => {
                const isEmpty = data.length < 1 ? true : false;

                setEguUglOrderPurchaseDetailDataIsEmpty(isEmpty);

                onDetailEmpty(isEmpty);
            }}
            onModifyViewUrl={(url) => `${url}/${onSelectMst.orderPurchaseId}`}
            noCreate
            noEdit
            noDelete
            noExcel
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={eguUglOrderPurchaseDetailSchema && eguUglOrderPurchaseDetailSchema.name}
                        accessMethod="POST"
                    >
                        <MomSysOrderPurchaseDetailButton
                            id={id}
                            schema={eguUglOrderPurchaseDetailSchema}
                            onSelectMst={onSelectMst}
                            disabled={onSelectMst.approvalState ? true : false || onSelectMst.length <= 0 ? true : false}
                            onSuccess={onSuccess}
                            modifyUrlCallback={(url) => `${url}/create/${onSelectMst.orderPurchaseId}`}
                            onDialogUpdateDetail={onDialogUpdateDetail}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={eguUglOrderPurchaseDetailSchema && eguUglOrderPurchaseDetailSchema.name}
                        accessMethod={
                            eguUglOrderPurchaseDetailSchema &&
                            (eguUglOrderPurchaseDetailSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <UpdateRecordButton
                            id={id}
                            schema={eguUglOrderPurchaseDetailSchema}
                            grid={eguUglOrderPurchaseDetailGrid}
                            disabled={onSelectMst.approvalState || eguUglOrderPurchaseDetailDataIsEmpty}
                            onSuccess={onSuccess}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={eguUglOrderPurchaseDetailSchema && eguUglOrderPurchaseDetailSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteRecordButton
                            id={id}
                            schema={eguUglOrderPurchaseDetailSchema}
                            grid={eguUglOrderPurchaseDetailGrid}
                            color="secondary"
                            disabled={onSelectMst.approvalState || eguUglOrderPurchaseDetailDataIsEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onPartialFailure}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={eguUglOrderPurchaseDetailSchema && eguUglOrderPurchaseDetailSchema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <SaveToExcelButton
                            id={id}
                            grid={eguUglOrderPurchaseDetailGrid}
                            view={view}
                            color="primary"
                            exportFormatItem={() => {}}
                            disabled={eguUglOrderPurchaseDetailDataIsEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
        />
    );
}

export default EguUglOrderPurchaseDetail;
